import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=b954d810&scoped=true&"
import script from "./CartButton.vue?vue&type=script&lang=js&"
export * from "./CartButton.vue?vue&type=script&lang=js&"
import style0 from "./CartButton.vue?vue&type=style&index=0&id=b954d810&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b954d810",
  null
  
)

export default component.exports